module.exports = __webpack_public_path__ + "img/case_03_2.de03cb55.png";